import React from "react";

export function VehicleDamageReportStep3({ photos, notes, onNotesChange, onInsertPhoto, onRemovePhoto, t }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        gap: "24px",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <p
          style={{
            fontSize: "14px",
            color: "#333",
            margin: 0,
            lineHeight: "1.4",
          }}
        >
          {t("keylessReturnDamageSubmit")}
        </p>
      </div>

      <button
        onClick={onInsertPhoto}
        style={{
          backgroundColor: "#8CC63F",
          color: "#FFFFFF",
          border: "none",
          borderRadius: "8px",
          padding: "14px",
          fontSize: "16px",
          fontWeight: "bold",
          cursor: "pointer",
          width: "100%",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {t("keylessReturnInsertPhoto")}
      </button>

      {photos && photos.length > 0 && (
        <div
          style={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "10px",
          }}
        >
          {photos.map((photo, index) => (
            <div
              key={photo.id || index}
              style={{
                position: "relative",
                borderRadius: "8px",
                overflow: "hidden",
                border: "1px solid #E0E0E0",
                aspectRatio: "16/9",
              }}
            >
              <img
                src={photo.url || photo.dataUrl}
                alt={`Dano ${index + 1}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
              <button
                onClick={() => onRemovePhoto(index)}
                style={{
                  position: "absolute",
                  top: "4px",
                  right: "4px",
                  width: "22px",
                  height: "22px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(0,0,0,0.6)",
                  color: "white",
                  border: "none",
                  fontSize: "13px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: 1,
                  padding: 0,
                }}
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}

      <div
        style={{
          width: "100%",
          backgroundColor: "#FFFFFF",
          border: "1px solid #E0E0E0",
          borderRadius: "8px",
          padding: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          textAlign: "left",
          boxSizing: "border-box",
        }}
      >
        <label
          style={{
            display: "block",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "12px",
          }}
        >
          {t("keylessReturnAdditionalInfo")}
        </label>

        <textarea
          value={notes}
          onChange={(e) => onNotesChange(e.target.value)}
          placeholder="PORTA FRENTE ESQ / FRONT LEFT DOOR"
          style={{
            width: "100%",
            minHeight: "60px",
            padding: "12px",
            border: "1px solid #BDBDBD",
            borderRadius: "6px",
            fontSize: "12px",
            color: "#333",
            boxSizing: "border-box",
            resize: "vertical",
            fontFamily: "inherit",
          
          }}
        />
      </div>
    </div>
  );
}
